import { DefaultApi } from '@/api/member/api';
import { axiosInstance } from '@/utils/axiosInstance';

export const deleteMember = async (memberId: string): Promise<void> => {
  const api = new DefaultApi(undefined, undefined, axiosInstance);
  api.deleteMember(memberId);
};
